var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      !!_vm.value
        ? _c(
            "v-dialog",
            {
              attrs: { "max-width": "600px", persistent: "" },
              model: {
                value: _vm.value,
                callback: function ($$v) {
                  _vm.value = $$v
                },
                expression: "value",
              },
            },
            [
              _c(
                "v-card",
                { attrs: { flat: "" } },
                [
                  _c("v-card-title", { staticClass: "pt-3 dialog-title" }, [
                    _vm._v(" Machine Credential "),
                  ]),
                  _c("v-card-title", { staticClass: "pt-2 pb-1" }, [
                    _c("div", { staticClass: "dialog-text" }, [
                      _vm._v("Machine Name : " + _vm._s(_vm.value.MachineName)),
                    ]),
                  ]),
                  _c("v-card-title", { staticClass: "pt-2 pb-0" }, [
                    _c("div", { staticClass: "dialog-text" }, [
                      _vm._v("Machine Id : " + _vm._s(_vm.value.MachineId)),
                    ]),
                  ]),
                  _c("v-divider", { staticClass: "ma-4" }),
                  _c("v-card-title", { staticClass: "pt-0" }, [
                    _c("div", { staticClass: "dialog-title" }, [
                      _vm._v("Certificates"),
                    ]),
                  ]),
                  _c("v-card-text", [
                    _c(
                      "div",
                      { staticClass: "text-container" },
                      [
                        _c(
                          "v-icon",
                          { attrs: { size: "30", color: "green" } },
                          [_vm._v("mdi-certificate")]
                        ),
                        _c("span", { staticClass: "title-text" }, [
                          _vm._v(
                            " The Debian and Zip files contain the machine key, pem certificate and private key."
                          ),
                        ]),
                      ],
                      1
                    ),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "text-container",
                      attrs: { align: "center", justify: "center" },
                    },
                    [
                      _c("v-icon", { attrs: { size: "30", color: "red" } }, [
                        _vm._v("mdi-alert"),
                      ]),
                      _c("span", { staticClass: "subtitle-text" }, [
                        _vm._v(
                          "This is the only time you can download these files."
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "v-card-actions",
                    { staticClass: "mt-0 pt-0 mb-0 pt-5" },
                    [
                      _c("v-spacer"),
                      _c(
                        "span",
                        [
                          _vm.value
                            ? _c(
                                "v-btn",
                                {
                                  attrs: { text: "", color: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.downloadFile(
                                        _vm.value.DebianFilePath
                                      )
                                    },
                                  },
                                },
                                [_vm._v("Download Debian")]
                              )
                            : _vm._e(),
                          _vm.value
                            ? _c(
                                "v-btn",
                                {
                                  attrs: { text: "", color: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.downloadFile(
                                        _vm.value.ZipFilePath
                                      )
                                    },
                                  },
                                },
                                [_vm._v("Download Zip")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("v-divider", { staticClass: "ma-4" }),
                  _c(
                    "v-card-actions",
                    { staticClass: "mt-0 pt-0 mb-0 pb-0" },
                    [
                      _c("v-spacer"),
                      _c(
                        "span",
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                text: "",
                                color: "primary",
                                disabled: !_vm.isDownloaded,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.$emit("input", null)
                                },
                              },
                            },
                            [_vm._v("Close")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }